import type { SVGProps } from 'react';

const MergeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.25 25.666v-5.833m0-11.667V2.333M2.334 5.25h5.833m-5.833 17.5h5.833m7-19.25-2.023 5.26c-.33.855-.494 1.283-.75 1.643a3.5 3.5 0 0 1-.824.824c-.36.256-.787.42-1.643.75L4.667 14l5.26 2.023c.856.329 1.283.493 1.643.75a3.5 3.5 0 0 1 .824.823c.256.36.42.788.75 1.643l2.023 5.26 2.023-5.26c.33-.855.494-1.283.75-1.643a3.5 3.5 0 0 1 .824-.824c.36-.256.787-.42 1.643-.75L25.667 14l-5.26-2.024c-.856-.328-1.284-.493-1.643-.749a3.5 3.5 0 0 1-.825-.824c-.255-.36-.42-.788-.749-1.643z"
    />
  </svg>
);

export default MergeIcon;
